import Vue from 'vue';

export default function (to, from, next)
{
        Vue.http.interceptors.push(function(request)
        {
            const server = sessionStorage.getItem('zp-server') || false;
            
            if(server) request.params['zp-server'] = server;
   
            return function(response)
            {
                // if(!server) sessionStorage.setItem('zp-server', response.headers.map['zp-server'][0])
            };
        });

    return next();
}